<template>
  <div class="record-page">
    <!-- 标签栏 -->
    <ul class="record-tabs">
      <li
        v-for="tab in tabs"
        :key="tab.id"
        :class="{ active: currentTab === tab.id }"
        @click="switchTab(tab.id)"
      >
        {{ tab.label }}
      </li>
    </ul>

    <!-- 内容区 -->
    <div class="record-content">
      <LikeRecords v-if="currentTab === 1" />
      <HistoryRecords v-if="currentTab === 2" />
    </div>
  </div>
</template>

<script>
import LikeRecords from '@/components/record/LikeRecords.vue'
import HistoryRecords from '@/components/record/HistoryRecords.vue'

export default {
  name: 'RecordVue',
  components: {
    LikeRecords,
    HistoryRecords
  },
  data() {
    return {
      currentTab: 1,
      tabs: [
        { id: 1, label: this.$t('_jl._wxhd') },
        { id: 2, label: this.$t('_jl._lsjl') }
      ]
    }
  },
  created() {
    const tabId = parseInt(this.$route.query.i)
    if (tabId === 1 || tabId === 2) {
      this.currentTab = tabId
    }
  },
  methods: {
    switchTab(id) {
      this.currentTab = id
      // 更新 URL 参数
      this.$router.replace({ query: { ...this.$route.query, i: id } })
    }
  }
}
</script>

<style scoped>
/* ============================================================
   记录页面 - 暗色主题
   ============================================================ */

.record-page {
  max-width: 1440px;
  margin: 0 auto;
  padding: 20px 24px 40px;
  background: #0b0d0f;
  min-height: 100vh;
  color: #e8edf2;
}

/* ============================================================
   标签栏
   ============================================================ */
.record-tabs {
  display: flex;
  gap: 4px;
  padding: 0 0 20px;
  margin: 0 0 24px;
  list-style: none;
  border-bottom: 1px solid #1a1f26;
}

.record-tabs li {
  padding: 10px 28px;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 500;
  color: #8a949f;
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  position: relative;
}

.record-tabs li:hover {
  color: #e8edf2;
  background: rgba(255, 255, 255, 0.04);
}

.record-tabs li.active {
  color: #e8edf2;
  background: rgba(229, 9, 20, 0.12);
}

/* 底部高亮条 */
.record-tabs li.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 50%;
  transform: translateX(-50%);
  width: 40%;
  height: 3px;
  background: #e50914;
  border-radius: 4px 4px 0 0;
}

/* ============================================================
   内容区
   ============================================================ */
.record-content {
  background: #0f1419;
  border-radius: 16px;
  border: 1px solid #1a1f26;
  padding: 20px 24px;
  min-height: 400px;
}

/* ============================================================
   子组件样式穿透
   ============================================================ */
.record-content :deep(.like-container),
.record-content :deep(.history-container) {
  background: transparent;
  color: #e8edf2;
}

/* ============================================================
   响应式
   ============================================================ */
@media (max-width: 768px) {
  .record-page {
    padding: 12px 12px 30px;
  }

  .record-tabs {
    gap: 2px;
    padding-bottom: 16px;
    margin-bottom: 16px;
  }

  .record-tabs li {
    padding: 8px 20px;
    font-size: 14px;
  }

  .record-tabs li.active::after {
    width: 30%;
  }

  .record-content {
    padding: 14px 16px;
    border-radius: 12px;
    min-height: 300px;
  }
}

@media (max-width: 480px) {
  .record-tabs li {
    padding: 6px 14px;
    font-size: 13px;
    flex: 1;
    text-align: center;
  }

  .record-content {
    padding: 10px 12px;
    min-height: 250px;
  }
}
</style>